import { styled } from '@mui/material';
import { useEffect } from 'react';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import Stack from 'shell/components/Stack';
import { PdfLoader } from 'shell/pdf_viewer_utils';
import PdfHighlighter from 'shell/pdf_viewer_utils/components/PdfHighlighter';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();

const HIGHLIGHT_CLASS_NAME = 'pdf-highlight';

const PDFViewer = ({
    url,
    highlights,
    inlineComments,
    setInlineComments,
    selectedInlineCommentId,
    setSelectedInlineCommentId,
    isFullScreen,
    setIsFullScreen,
    isStudent = false,
}) => {
    useEffect(() => {
        if (highlights.length) {
            const els = document.getElementsByTagName('mark');
            if (els?.length) {
                els[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(highlights.map((h) => h.value))]);

    return (
        <RootStack className={'joyride-step-7'} selectedInlineCommentId={selectedInlineCommentId}>
            <PdfLoader url={url}>
                {(document) => (
                    <PdfHighlighter
                        url={url}
                        document={document}
                        highlights={highlights}
                        inlineComments={inlineComments || []}
                        setInlineComments={setInlineComments}
                        selectedInlineCommentId={selectedInlineCommentId}
                        setSelectedInlineCommentId={setSelectedInlineCommentId}
                        isFullScreen={isFullScreen}
                        setIsFullScreen={setIsFullScreen}
                        isStudent={isStudent}
                    />
                )}
            </PdfLoader>
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme, selectedInlineCommentId }) => {
    return {
        [`& .${HIGHLIGHT_CLASS_NAME}`]: {
            borderBottom: selectedInlineCommentId
                ? `1px solid ${theme.palette.ensightful.success[700]}`
                : `1px solid ${theme.palette.ensightful.warning[700]}`,
            background: selectedInlineCommentId
                ? `${theme.palette.ensightful.success[500]}40`
                : `${theme.palette.ensightful.warning[500]}40`,
        },
    };
});

export default PDFViewer;
